import { Box, TextButton } from '@zillow/constellation-10';
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContextProvider';

type ViewLeadsProps = {
  isEnterpriseCustomer: boolean;
};

export default function ViewLeads({ isEnterpriseCustomer }: ViewLeadsProps): JSX.Element {
  const { paths } = useContext(AppContext);
  const ctaText = isEnterpriseCustomer ? 'View contacts' : 'View leads';

  return (
    <Box css={{ borderBottom: '1px solid', borderColor: 'border.subtle', padding: 'loose' }}>
      <TextButton asChild textStyle="body-sm-bold">
        <a href={paths.leadsPage}>{ctaText}</a>
      </TextButton>
    </Box>
  );
}
